import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["type", "disabled", "aria-busy", "aria-disabled", "aria-label"]

import { computed } from "vue";

const baseClasses =
  "relative flex w-full items-center justify-center border rounded-md py-2 px-8 text-sm font-medium transition-colors duration-200 shadow-md focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-offset-2 disabled:opacity-50 disabled:cursor-not-allowed";


export default /*@__PURE__*/_defineComponent({
  __name: 'SaButton',
  props: {
    type: {},
    loading: { type: Boolean },
    disabled: { type: Boolean },
    variant: {}
  },
  emits: ["click"],
  setup(__props: any, { emit: __emit }) {

const props = __props;

const emit = __emit;

const handleClick = (e: MouseEvent) => {
  if (!props.loading && !props.disabled) {
    emit("click", e);
  }
};

const variantClasses = computed(() => {
  switch (props.variant) {
    case "secondary":
      return "bg-clay-950 text-clay-100 border-transparent hover:bg-clay-900 hover:text-clay-50";
    case "danger":
      return "bg-red-600 text-white border-transparent hover:bg-red-700";
    case "ghost":
      return "bg-gray-100 text-gray-900 border-transparent hover:bg-gray-200";
    case "primary":
    default:
      return "bg-electric-700 text-white border-transparent hover:bg-electric-600 ";
  }
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("button", {
    type: props.type || 'button',
    disabled: props.disabled || props.loading,
    "aria-busy": props.loading,
    "aria-disabled": props.disabled || props.loading,
    role: "button",
    onClick: handleClick,
    class: _normalizeClass([baseClasses, variantClasses.value]),
    "aria-label": props.type || 'button'
  }, [
    (props.loading)
      ? _renderSlot(_ctx.$slots, "loading", { key: 0 }, () => [
          _cache[0] || (_cache[0] = _createTextVNode(" Saving... "))
        ])
      : _renderSlot(_ctx.$slots, "default", { key: 1 }, () => [
          _cache[1] || (_cache[1] = _createTextVNode(" Save "))
        ])
  ], 10, _hoisted_1))
}
}

})